import React from "react";
import { LEAVE_STATUS_FILTER_OPTIONS } from "../../../app/utils/constants/leaveStatusFilter";
import "./LeaveStatusFilter.scss";

const LeaveStatusFilter = ({ value = "", onChange, className = "" }) => {
  return (
    <div
      className={`leave-status-filter ${className}`.trim()}
      role="group"
      aria-label="Filter by leave status"
    >
      {LEAVE_STATUS_FILTER_OPTIONS.map((option) => {
        const isActive = value === option.value;
        return (
          <button
            key={option.value || "all"}
            type="button"
            className={`leave-status-filter__btn${
              isActive ? " leave-status-filter__btn--active" : ""
            } leave-status-filter__btn--${option.value || "all"}`}
            aria-pressed={isActive}
            onClick={() => onChange(option.value)}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
};

export default LeaveStatusFilter;
